import { Injectable } from '@angular/core';
import { ApiConfigService } from './api-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface UploadResponse {
  success: boolean;
  imageUrl: string;
  cloudinaryId: string;
  provider: string;
  message?: string;
}

export interface MultiUploadResponse {
  success: boolean;
  images: { url: string; cloudinaryId: string; order: number }[];
  count: number;
  provider: string;
}

export interface ExcelParseResponse {
  success: boolean;
  totalRows: number;
  validCount: number;
  errorCount: number;
  products: any[];
  errors: { row: number; title?: string; reason: string }[];
}

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/upload`; }

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  uploadImage(file: File): Observable<UploadResponse> {
    const formData = new FormData();
    formData.append('image', file);
    return this.http.post<UploadResponse>(this.apiUrl, formData);
  }

  uploadMultipleImages(files: File[]): Observable<MultiUploadResponse> {
    const formData = new FormData();
    files.forEach(f => formData.append('images', f));
    return this.http.post<MultiUploadResponse>(`${this.apiUrl}/multiple`, formData);
  }

  parseExcel(file: File): Observable<ExcelParseResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<ExcelParseResponse>(`${this.apiUrl}/parse-excel`, formData);
  }
}
